import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProffitSearchShareReceiveHeaderReadAt } from '../../../../actions/ProffitSearchReceiveHeaderAction';
import { apiGetListProffitSearchReceive } from '../../../../actions/ProffitSearchSlideActions';
import { apiGetOneProfile } from '../../../../actions/ProfileActions';
import { propShape } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import { useSlideSearchReceive } from '../../../../helpers/use/proffit_search/common/useSlideSearchReceive';
import { useUnmountRef } from '../../../../helpers/use/useHook';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import ModalPortal from '../../../Ui/Modal/ModalPortal';
import ProffitSearchInformationHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchInformationHoc';
import ProffitSearchReceiveHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchReceiveHoc';
import ProffitSearchRegistrationDeviceHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchRegistrationDeviceHoc';
import ProffitSearchTutorialHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchTutorialHoc';
import SlideSearchReceiveModal from '../../../Ui/SlideSearch/Modal/SlideSearchReceiveModal';
import SlideSearchListOneTemplate from '../../List/SlideSearchListOneTemplate';
import ReceivedUser from './Parts/ReceiveFolder/ReceiveList/ReceivedUser';
const ReceiveFolderOneInner = (props) => {
    const { proffitSearch, receive } = props;
    const { content, createdAt, email, firstName, id, lastName, photo, receivedAt, } = receive;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const profile = useSelector((state) => state.profile);
    const fromName = !lastName && !firstName ? email : `${lastName} ${firstName}`;
    const pans = useMemo(() => [
        {
            link: '/mypage',
            text: 'マイページ',
        },
        {
            link: '/proffit_search',
            text: 'PROFFIT SEARCH',
        },
        {
            link: '/proffit_search/receive_folder',
            text: '受信フォルダ',
        },
        {
            text: `${fromName}からの共有`,
        },
    ], [fromName]);
    const { hideModal, isShowModal, onClickReceive, updateReceive } = useSlideSearchReceive.useSlideSearchReceiveModal(profile, dispatch, unmountRef);
    const initialValues = useMemo(() => ({ id }), [id]);
    const wrapAction = useCallback((params, meta) => apiGetListProffitSearchReceive(id, params, meta), [id]);
    useEffect(() => {
        dispatch(updateProffitSearchShareReceiveHeaderReadAt(id));
        dispatch(apiGetOneProfile());
    }, [dispatch, id]);
    return (_jsx(SlideSearchListOneTemplate, { action: wrapAction, keywordPlaceholder: `${fromName} からの共有の検索`, pans: pans, proffitSearch: proffitSearch, renderHeader: () => (_jsxs("div", Object.assign({ className: 'proffit_search_receive_information' }, { children: [_jsx(ReceivedUser, { content: content, createdAt: createdAt, firstName: firstName, id: id, lastName: lastName, onClick: onClickReceive, photo: photo, receivedAt: receivedAt }, id), _jsx(ModalPortal, { children: _jsx(SlideSearchReceiveModal, { hideModal: hideModal, initialValues: initialValues, isShow: isShowModal, onSubmit: updateReceive }) })] }))), title: `${fromName}からの共有` }));
};
ReceiveFolderOneInner.propTypes = {
    proffitSearch: propShape().isRequired,
    receive: propShape().isRequired,
};
const ReceiveFolderOne = compose(AuthenticationHoc({ isCanUseProffitSearch: true }), ProffitSearchRegistrationDeviceHoc(), ProffitSearchTutorialHoc(), ProffitSearchInformationHoc(), ProffitSearchReceiveHoc())(ReceiveFolderOneInner);
export default ReceiveFolderOne;
